import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { v4 as uuidV4 } from 'uuid';
import AssociatedAssets from '../../common/sections/associatedAssets';
const EmployeeAssets = ({
  assets: _assets = [],
  onChange,
  userID
}) => {
  const defaultData = asset => ({
    id: uuidV4().toUpperCase(),
    appCreated: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
    assetID: asset.id,
    name: asset.name,
    appCreatorID: userID
  });
  const handleAdd = asset => {
    const items = JSON.parse(JSON.stringify(_assets));
    items.push(defaultData(asset));
    onChange('assets', items);
  };
  const handleRemove = index => {
    const parsedAssets = JSON.parse(JSON.stringify(_assets));
    parsedAssets.splice(index, 1);
    onChange('assets', parsedAssets);
  };
  const handleChange = (index, name, value) => onChange(`assets[${index}]/${name}`, value);
  return /*#__PURE__*/React.createElement(AssociatedAssets, {
    assets: _assets,
    onChange: handleChange,
    onRemove: handleRemove,
    onAdd: handleAdd
  });
};
EmployeeAssets.propTypes = {
  assets: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func.isRequired,
  userID: PropTypes.string.isRequired
};
export default EmployeeAssets;